import firebase from 'firebase/app';
import 'firebase/auth';

/**
 * Refresh the Firebase ID token when it expires within this window (milliseconds).
 * Matches contracts-cms proactive refresh before REST calls.
 */
export const TOKEN_REFRESH_WINDOW_MS = 5 * 60 * 1000;

/**
 * Returns the current user's ID token metadata, or null when signed out.
 *
 * @returns {Promise<import('firebase').auth.IdTokenResult | null>}
 */
export const getToken = async () => {
  const user = firebase.auth().currentUser;

  if (!user) {
    return null;
  }

  return user.getIdTokenResult();
};

/**
 * Forces Firebase to mint a fresh ID token for the signed-in user.
 *
 * @returns {Promise<import('firebase').auth.IdTokenResult>}
 */
export const forceRefreshUser = async () => {
  const user = firebase.auth().currentUser;

  if (!user) {
    throw new Error('No current user');
  }

  return user.getIdTokenResult(true);
};

/**
 * True when the token is expired or will expire inside {@link TOKEN_REFRESH_WINDOW_MS}.
 *
 * @param {import('firebase').auth.IdTokenResult | null | undefined} tokenResult
 * @returns {boolean}
 */
export const isTokenExpiringSoon = tokenResult => {
  if (!tokenResult?.expirationTime) {
    return false;
  }

  return new Date(tokenResult.expirationTime).getTime() < Date.now() + TOKEN_REFRESH_WINDOW_MS;
};
